<template>
  <div class="mission-referral-code">
    <router-link :to="{ name: 'MypageReferralCodePage' }" class="mission-referral-code-link">{{
      $tc('MissionPage.referralCode')
    }}</router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * ミッション画面 ミッション達成状況 紹介コード確認ボタンパーツ
 */
export default defineComponent({
  name: 'MissionReferralCodeParts',
})
</script>

<style scoped lang="scss">
.mission-referral-code {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
}

.mission-referral-code-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  font-size: 13px;
  font-weight: 700;
  color: #ff5d5d;
  letter-spacing: 0.04em;
  border: 1px solid rgba(#ff5d5d, 0.4);
  border-radius: 4px;
}
</style>
